const CHIP_ACCENT_MARK_CLASS =
  'relative pl-3 before:absolute before:top-1/2 before:left-1 before:h-3.5 before:w-0.75 before:-translate-y-1/2 before:rounded-full';

export const INACTIVE_HOLIDAY_NAME_CLASS = 'line-through decoration-muted-foreground/60';

export const HOLIDAY_CHIP_CLASS = {
  active: 'rounded-md bg-primary/8 pl-1.5 text-primary',
  inactive: `rounded-md border border-dashed border-muted-foreground/45 bg-muted/50 text-muted-foreground ${INACTIVE_HOLIDAY_NAME_CLASS}`,
} as const;

export const HOLIDAY_MARK_CLASS = {
  active: 'bg-primary',
  inactive: 'border border-dashed border-muted-foreground/60 bg-card',
} as const;

export const WEEKEND_CHIP_CLASS = `${CHIP_ACCENT_MARK_CLASS} rounded-md bg-muted text-muted-foreground before:bg-muted-foreground/50`;
export const OUT_OF_MONTH_CELL_CLASS = 'cursor-not-allowed bg-muted/40';

export const MONTH_DAY_KINDS = ['working', 'weekend', 'holiday'] as const;
export type MonthDayKind = (typeof MONTH_DAY_KINDS)[number];

export const MONTH_DAY_KIND_LABEL: Record<MonthDayKind, string> = {
  working: 'Working days',
  weekend: 'Weekends',
  holiday: 'Holidays',
};

export const OPENED_DAY_FLASH_MS = 3000;

export const HOLIDAY_NAME_MAX_LENGTH = 100;
export const HOLIDAY_DESCRIPTION_MAX_LENGTH = 500;

export const MONTH_PARAM_FORMAT = 'yyyy-MM';
export const MONTH_PARAM_PATTERN = /^\d{4}-(0[1-9]|1[0-2])$/u;
export const MONTH_LABEL_FORMAT = 'MMMM yyyy';
